import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tilt from "react-parallax-tilt";
import SocialMedia from "../SocialMedia/SocialMedia";
import laundryLine from "../../Assets/laundry-line.webp";
import './Contact.scss';
import Seo, { organizationSchema } from "../Seo/Seo";

function ContactForm() {
  const [result, setResult] = useState("");
  const [emailError, setEmailError] = useState("");

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    setEmailError("");

    const formData = new FormData(event.target);
    const email = formData.get("email");

    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address.");
      setResult("");
      return;
    }

    formData.append("access_key", process.env.REACT_APP_FORM_KEY);

    formData.append("from_name", "Klean Leaf Website");
    formData.append("subject", "Klean Leaf - New Contact Form Submission");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <Container fluid className="contact-section primary page-top-settings">
      <Seo
        title="Request Private Label Laundry Sheet Samples | Klean Leaf"
        description="Request private label laundry detergent sheet samples, wholesale laundry sheet quotes, custom packaging support, and buyer assistance from Klean Leaf."
        path="/contact"
        schema={organizationSchema}
      />
      <Container>
        <Row>
          <h1 className="center-text">Request Laundry Detergent Sheet Samples</h1>
          <h2 className="page-title">
            Start a Private Label Project
          </h2>
          <p className="page-subtitle">Tell us about your brand, target pack format, formula needs, and launch timeline.</p>
        </Row>
        <Row>
          <Col md={6} className="kitty">
            <Tilt>
              <img
                src={laundryLine}
                alt="Laundry line illustration for private label detergent sheet samples"
                className="img-fluid"
                decoding="async"
              />
            </Tilt>
          </Col>
          <Col md={5} className="contact-right equal-height-cards">
            <form onSubmit={onSubmit} className="contact-form">
              <label>Name *</label>
              <input type="text" name="name" required />

              <label>Email *</label>
              <input
                type="email"
                name="email"
                required
                onChange={(e) => {
                  setEmailError(validateEmail(e.target.value) ? "" : "Please enter a valid email address.");
                }}
                onFocus={() => setEmailError("")}
              />
              {emailError && <span className="error-message">{emailError}</span>}

              <label>Company</label>
              <input type="text" name="company" />

              <label>Message</label>
              <textarea name="message" required maxLength="2000"></textarea>

              <button type="submit" className="submit-button primary-btn">Request Samples or Quote</button>
            </form>
            <span className="form-result">{result}</span>
          </Col>
        </Row>

        <Row className="mt-5">
          <h2>Talk to Our Columbus, Ohio Team</h2>
          <p>Email <strong>hello@kleanleaf.us</strong> or use the form to request samples, a laundry sheet quote, packaging options, retail package MOQ details, MSDS/testing documents, or logistics support.</p>
          <p>Our Office: Columbus, Ohio</p>
          <p>Helpful details to include: target market, pack count, fragrance-free or scented preference, packaging type, estimated order quantity, and desired launch date.</p>
          <p>Follow us on:</p>
          <SocialMedia />
        </Row>
      </Container>
    </Container>
  );
}

export default ContactForm;
